import { useState, useContext, useEffect, useCallback, useRef } from 'react';

import { useAsyncRequest } from 'hooks';
import { Context as StoreContext, types } from 'ui/containers/StoreContext';

const STORAGE_KEY = 'test_results';
export const clean = () => {
  localStorage.removeItem(STORAGE_KEY)
  sessionStorage.removeItem(STORAGE_KEY)
}
export default function useTestResult(name, options = {}) {
  const optionsRef = useRef(options)
  const [state, dispatch] = useContext(StoreContext);
  const ctxResult = state[types.TEST_RESULTS]?.[name];
  const ctxMeta = state[types.TEST_RESULTS_META]?.[name];
  const ctxResultRef = useRef(ctxResult)
  const ctxMetaRef = useRef(ctxMeta)
  const [storageResult, setStorageResult] = useState(null);
  const storageRef = useRef(null)
  const { isLoading, data: serverData, invoke } = useAsyncRequest({initialIsLoading: true});
  const result = serverData || ctxResult || storageResult?.result;
  const meta = ctxMeta || storageResult?.meta;
  useEffect(() => {
    storageRef.current = name?.startsWith('main') ? localStorage : sessionStorage
  }, [name])
  const parseStorageItems = useCallback(() => {
    try {
      const storage = storageRef.current || localStorage;
      return JSON.parse(storage.getItem(STORAGE_KEY));
      // eslint-disable-next-line no-empty
    } catch {}
    return null;
  }, []);
  useEffect(() => {
    ctxResultRef.current = ctxResult
    ctxMetaRef.current = ctxMeta
  }, [ctxResult, ctxMeta])
  useEffect(() => {
    invoke(async () => {
      let serverResult = null
      if (optionsRef.current.getResultById) {
        serverResult = await optionsRef.current.getResultById();
      }
      const parsedStorageResults = parseStorageItems();
      if (
        parsedStorageResults?.[name]?.result
      ) {
        setStorageResult(parsedStorageResults[name]);
      }
      if (optionsRef.current.onLoad) {
        const testResult = serverResult || ctxResultRef.current || parsedStorageResults?.[name]?.result
        const testMeta = ctxMetaRef.current || parsedStorageResults?.[name]?.meta
        optionsRef.current.onLoad(testResult, testMeta)
      }
      return serverResult
    })
  }, [name, invoke, parseStorageItems]);

  const setResult = useCallback(
    (newResult, newMeta) => {
      dispatch({
        type: types.SET_TEST_RESULT,
        payload: {
          result: newResult,
          name,
        },
      });
      dispatch({
        type: types.SET_TEST_RESULT_META,
        payload: {
          meta: newMeta,
          name,
        },
      });
      const storage = storageRef.current || localStorage;
      const newResults = { ...(parseStorageItems() || {}) };
      newResults[name] = {
        result: newResult,
        meta: newMeta,
      };
      storage.setItem(STORAGE_KEY, JSON.stringify(newResults));
    },
    [name, dispatch, parseStorageItems]
  );
  return {
    result,
    meta,
    isLoading,
    setResult,
  };
}
